
interestFlags.classy.controller({
    name: 'InterestFlagsController',
    inject: ['$scope', '$rootScope', 'FlagModelService', 'HelpSystemModelService', 'authServiceFactory', 'ModelService', '$rootScope',
            'standardCudArrayFactory', '$q'],
    init: function()
    {
    	this.$.arrayCud = new this.standardCudArrayFactory(this.FlagModelService, this.authServiceFactory.getAuth().schoolID, this.FlagModelService.get(), this, ['items']);
        this.$.FlagModelService = this.FlagModelService;
        this.$rootScope.model = this.FlagModelService;
        this.$.HelpSystemModelService = this.HelpSystemModelService;
        this.$.html = "<help-button active='active[0]' help-msg='HelpSystemModelService.get()[0].helpText'></help-button>";
        this.$.versionNo = this.versionNo;

        this.$.fieldAbbr = [
            {code: "ALI", name: "Alimony (income)"},
            {code: "ALE", name: "Alimony (expense)"},
            {code: "REC", name: "All Real Estate (# of)"},
            {code: "REV", name: "All Real Estate ($ value)"},
            {code: "AIT", name: "Annual Income"},
            {code: "APP", name: "Applicants"},
            {code: "TUI", name: "Applicants (total)"},
            {code: "AST", name: "Assets (total)"},
            {code: "AIN", name: "Auto Insurance"},
            {code: "BSA", name: "Business Assets"},
            {code: "BI", name: "Business Income"},
            {code: "CAP", name: "Capital Gains"},
            {code: "COD", name: "Certificate of Deposit"},
            {code: "CHA", name: "Charity"},
            {code: "CHK", name: "Checking Account"},
            {code: "CHC", name: "Child Care"},
            {code: "CSI", name: "Child Support (income)"},
            {code: "CSE", name: "Child Support (expense)"},
            {code: "CCD", name: "Credit Card Debt"},
            {code: "DEP", name: "Dependents"},
            {code: "DIV1", name: "Dividend/Interest Income"},
            {code: "EDU", name: "Educational Expenses"},
            {code: "ELE", name: "Electric"},
            {code: "EQL", name: "Equity Loan"},
            {code: "RMV", name: "Family Home Estimated Value"},
            {code: "MIN", name: "Health Insurance"},
            {code: "HEA", name: "Heating"},
            {code: "HIN", name: "Home Owners Insurance"},
            {code: "HOT", name: "Housing"},
            {code: "INT", name: "Insurances"},
            {code: "LIT", name: "Liabilities"},
            {code: "LIN", name: "Life Insurance"},
            {code: "SEP", name: "Married parents live in separate locations"},
            {code: "MEE", name: "Medical Expenses"},
            {code: "MOR", name: "Mortgage Payment"},
            {code: "NET", name: "Net Worth"},
            {code: "LET", name: "Open Letter Submitted"},
            {code: "OAS", name: "Other Assets"},
            {code: "OEX", name: "Other Expenses"},
            {code: "OIN", name: "Other Income"},
            {code: "OLI", name: "Other Liabilities"},
            {code: "LOA", name: "Other Loan Expenses"},
            {code: "OMV", name: "Other Real Estate Estimated Value"},
            {code: "TUT", name: "Other Tuitions"},
            {code: "EXC", name: "Parent explained by excuse"},
            {code: "PEL", name: "Personal Loans"},
            {code: "RPT", name: "Property Tax"},
            {code: "EST", name: "Real Estate Income"},
            {code: "RNT", name: "Rent"},
            {code: "RET", name: "Retirement Savings"},
            {code: "SAV", name: "Savings Account"},
            {code: "SIP", name: "Single parent"},
            {code: "SEC", name: "Stocks, Bonds, Securities"},
            {code: "SOD", name: "Support of Dependents"},
            {code: "TAX", name: "Taxes"},
            {code: "EXT", name: "Total Expenses"},
            {code: "INC", name: "Total Income"},
            {code: "TRA", name: "Trust Assets"},
            {code: "TRU", name: "Trust Income"},
            {code: "DIV", name: "Two families present"},
            {code: "UTT", name: "Utilities"},
            {code: "VEC", name: "Vehicles (# of)"},
            {code: "VEV", name: "Vehicles ($ value)"},
            {code: "VEH", name: "Vehicle Payments"}
        ];

        this.$.operatorAbbr = {"GT": " is greater than ", "LT": " is less than "};
        this.$.specialError = [];
        this.$.flagForm = new FormData();
    },
    cancelEdit: function()
    {
        this.$.arrayCud.cancelEdit();
        this.$.specialError = [];
        this.$.flagForm.$valid = true;
    },
    del: function(index)
    {
        this.$.arrayCud.del(index);
        this.$.specialError[index]=undefined;
    },
    edit: function(index)
    {
        this.$.arrayCud.toggleEditItem(index)
        this.activeChange(index);
    },
    add: function()
    {
        this.$.arrayCud.editItem[this.$.items.length] = true;
        this.$.items.push(this.$.arrayCud.model.new());

        //this.editItem[this.$.items.length] = true;
        //this.$.items.push(this.model.new());
    },
    activeChange: function(index)
    {
        this.$.specialError[index]=undefined;
        this.$.flagForm.$valid = true;
        for (var i = 0; i < this.$.items.length; i++) {
            if (i != index && this.$.items[index]!=undefined) {
                if (this.$.items[index].Field == 'EXC' || this.$.items[index].Field == 'LET' || this.$.items[index].Field == 'DIV' || this.$.items[index].Field == 'SIP' || this.$.items[index].Field == 'SEP') {
                    if (this.$.items[index].Field == this.$.items[i].Field) {
                        this.$.specialError[index] = 1;
                    }
                }
                else {
                    if (this.$.items[index].Field == this.$.items[i].Field && this.$.items[index].Operator == this.$.items[i].Operator && this.$.items[index].IsCaution == this.$.items[i].IsCaution && i != index) {
                        this.$.specialError[index] = 1;
                    }
                }
            }
        }
    },
    startSaveProcess: function(scope, instance, form)
    {
        var parent = this;
        function check(key) {
            if (parent.$.specialError[key]==1) {
                form.$valid = false;
            }
        }
        var promises = [];
        angular.forEach(this.$.items, function(value, key) {
            promises.push(check(key));
        })
        this.$q.all(promises).then(function() {
            if (form.$valid) {
                parent.$.arrayCud.startSaveProcess(scope, instance, form).then((response) => {
                    parent.$.items = response.data;
                });
            }
            else {
                instance.stop(-1);
            }
        });
    },
    makeEnglish: function(flag)
    {
        var item = '';
        item = this.$.fieldAbbr.find((i) => i.code === flag.Field).name;
        if (flag.Operator !== '')
            item += this.$.operatorAbbr[flag.Operator]
        if (flag.Amount !== '')
            item += flag.Amount
    	return item;
    }
 });
